module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.d0e072e2.png";